/**
 * @file apiErrorCodes.js
 * @description 后端业务错误码与默认文案（接口未返回 msg 时使用）
 * @module shared/utils/apiErrorCodes
 */
/** JSAPI 打赏/充值缺 wx_mp_open_id 时 prepare 返回（含 data.oauthAuthorizeUrl） */
export const ERR_WX_MP_OAUTH_REQUIRED = 10102
/** 未登录（购卷/充值等需登录接口） */
export const ERR_NOT_LOGIN = 10471
/** 未登录 / Redis 会话不存在（WEB 端） */
export const ERR_SESSION_NOT_FOUND = 10474
/** 认证过期（多见于小程序 JWT） */
export const ERR_AUTH_EXPIRED = 10475
/** 未登录读非首卷 */
export const ERR_VOL_NEED_LOGIN = 10701
/** 已登录未解锁付费卷 */
export const ERR_VOL_NEED_PAY = 10702
/** 购卷余额不足 */
export const ERR_GOLD_NOT_ENOUGH = 10703
/** 范围内无可购卷 */
export const ERR_VOL_PAY_EMPTY = 10705
/** 充值档位停用 */
export const ERR_GOLD_PACKAGE_DISABLED = 10706

export const API_ERROR_MESSAGES = {
  /** 验证码过期 */
  10111: '验证码过期,请重新获取',
  /** 验证码错误 */
  10112: '验证码输入有误，请重新输入',
  /** JSAPI：需公众号 OAuth（prepare code=10102） */
  [ERR_WX_MP_OAUTH_REQUIRED]: '请先完成微信授权后再继续',
  /** 未登录 */
  [ERR_NOT_LOGIN]: '请先登录后再操作',
  /** 打赏：金额非法 */
  10202: '打赏金额无效，请重新选择',
  /** 打赏：漫画不存在 */
  10203: '漫画不存在或已下架',
  /** 打赏：订单无效 */
  10204: '订单不存在或已关闭',
  /** 未登录读非首卷 */
  [ERR_VOL_NEED_LOGIN]: '请先登录后再阅读',
  /** 已登录未解锁付费卷 */
  [ERR_VOL_NEED_PAY]: '该卷尚未解锁，请先购买',
  /** 购卷余额不足 */
  [ERR_GOLD_NOT_ENOUGH]: '橘子币余额不足，请先充值',
  /** 范围内无可购卷 */
  [ERR_VOL_PAY_EMPTY]: '所选范围内没有可购买的卷',
  /** 充值档位停用 */
  [ERR_GOLD_PACKAGE_DISABLED]: '该充值档位已停用，请重新选择',
}

/** 微信支付通道未开时的固定提示（档位列表仍可展示） */
export const WECHAT_PAY_DISABLED_HINT = '微信支付未开启'

/** 登录/注册：需在验证码输入框下方展示、并高亮验证码框的错误码 */
export const AUTH_VERIFY_FIELD_ERROR_CODES = new Set([10111, 10112])

/**
 * @param {unknown} code
 * @returns {number | null}
 */
export function normalizeApiCode(code) {
  const n = Number(code)
  return Number.isFinite(n) ? n : null
}

/**
 * @param {unknown} code
 * @returns {boolean}
 */
export function isAuthVerifyFieldError(code) {
  const n = normalizeApiCode(code)
  return n != null && AUTH_VERIFY_FIELD_ERROR_CODES.has(n)
}

/**
 * 验证码类错误：优先用接口 msg，否则用登记表默认文案
 * @param {unknown} code
 * @param {string} [serverMsg]
 * @returns {string}
 */
export function resolveAuthVerifyErrorMessage(code, serverMsg) {
  const n = normalizeApiCode(code)
  if (n == null || !AUTH_VERIFY_FIELD_ERROR_CODES.has(n)) return ''
  const trimmed = serverMsg != null ? String(serverMsg).trim() : ''
  if (trimmed) return trimmed
  return API_ERROR_MESSAGES[n] || ''
}

/**
 * 通用：按错误码取默认说明（无映射时返回空字符串）
 * @param {unknown} code
 * @returns {string}
 */
export function getApiErrorMessageByCode(code) {
  const n = normalizeApiCode(code)
  if (n == null) return ''
  return API_ERROR_MESSAGES[n] || ''
}
